import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ILensObjnAction, initialState } from "./initialState";
export const useInstationStore = create<ILensObjnAction>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                changeStep(step: number) {
                    const prevlatestStep = get().step;
                    const latestStep =
                        step > prevlatestStep ? step : prevlatestStep;
                    set({
                        step,
                        isShowSelectWarning: false,
                        latestStep,
                    });
                },
                changePrice(price: number) {
                    set({ price });
                },
                // 归零lastest
                initLastStep(step = 0) {
                    set({
                        latestStep: step,
                    });
                },
                isDecen() {
                    set({
                        isDecentered: true,
                    });
                },
                notDecen() {
                    set({
                        isDecentered: false,
                    });
                },
                showWarning() {
                    set({ isShowSelectWarning: true });
                },
                setlensRx(lensRx: Record<string, any>) {
                    set({
                        lensRx: lensRx,
                    });
                },
                hideWarning() {
                    set({ isShowSelectWarning: false });
                },
                changesetlens(conditions: any) {
                    set({
                        conditions,
                    });
                },
            }),
            {
                name: "lensobj-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "lensobj-store",
        },
    ),
);
